import { Type } from 'class-transformer'

export class UserInfo {
  value!: string
  info!: {
    id: number
    name: string
    login?: string
    language: string
    type:	"USER"
  }
  error?:string
}

export class GetUsersInfo {
  @Type(() => UserInfo)
  data!: Array<UserInfo>
}
